import { getAuthScope } from "../helpers/session";

export const queryKeys = {
  patients: {
    all: ["patients"],
    list: (filters) => ["patients", "list", getAuthScope(), filters ?? {}],
    detail: (uuid) => ["patients", "detail", uuid],
    wizard: () => ["patients", "wizard", getAuthScope()],
    emrDocuments: (id) => ["patients", "emrDocuments", id],
  },
  payments: {
    all: ["payments"],
    cards: () => ["payments", "cards", getAuthScope()],
  },
  locations: {
    regions: ["locations", "regions"],
    addressesAll: ["locations", "addresses"],
    addresses: (userId) => ["locations", "addresses", userId ?? null],
    address: (uuid) => ["locations", "address", uuid],
    suggestions: (input) => ["locations", "suggestions", input ?? ""],
  },
  search: {
    autocomplete: (source, term) => [
      "search",
      "autocomplete",
      source ?? null,
      term ?? "",
    ],
  },
  specialities: {
    all: ["specialities"],
  },
  relations: {
    all: ["relations"],
  },
  visitTypes: {
    all: ["visitTypes"],
  },
  doctors: {
    all: ["doctors"],
    list: (filters) => ["doctors", "list", filters ?? {}],
    detail: (uuid) => ["doctors", "detail", uuid],
    signature: (uuid) => ["doctors", "signature", uuid],
    archived: (uuid) => ["doctors", "archived", uuid],
  },
  shifts: {
    all: ["shifts"],
    list: (filters) => ["shifts", "list", filters ?? {}],
    daySlots: (params) => ["shifts", "daySlots", params ?? {}],
  },
  notifications: {
    all: () => ["notifications", getAuthScope()],
  },
  serviceRequests: {
    all: ["serviceRequests"],
    list: (filters) => [
      "serviceRequests",
      "list",
      getAuthScope(),
      filters ?? {},
    ],
    detail: (uuid) => ["serviceRequests", "detail", uuid],
    calendarAll: ["serviceRequests", "calendar"],
    calendar: (body) => [
      "serviceRequests",
      "calendar",
      getAuthScope(),
      body ?? {},
    ],
    emrFilters: (body) => ["serviceRequests", "emrFilters", body ?? {}],
    groupEvents: (uuid) => ["serviceRequests", "groupEvents", uuid],
  },
  memberships: {
    all: ["memberships"],
    list: (filters) => ["memberships", "list", filters ?? {}],
    detail: (uuid) => ["memberships", "detail", uuid],
    forPatient: (payload) => ["memberships", "forPatient", payload ?? {}],
  },
  membershipTemplates: {
    all: ["membershipTemplates"],
    list: (filters) => ["membershipTemplates", "list", filters ?? {}],
    detail: (uuid) => ["membershipTemplates", "detail", uuid],
  },
  pastTestResults: {
    all: ["pastTestResults"],
    list: (patientUuid, filters) => [
      "pastTestResults",
      "list",
      patientUuid ?? null,
      filters ?? {},
    ],
    filters: (patientUuid, filters) => [
      "pastTestResults",
      "filters",
      patientUuid ?? null,
      filters ?? {},
    ],
  },
  currentUser: {
    me: (role) => ["currentUser", role, getAuthScope()],
  },
  twilio: {
    token: () => ["twilio", "token", getAuthScope()],
    channel: (requestId) => ["twilio", "channel", requestId],
  },
  admin: {
    totalPatients: ["admin", "totalPatients"],
    dashboard: (date) => ["admin", "dashboard", date ?? {}],
    shiftAppointments: (body) => ["admin", "shiftAppointments", body ?? {}],
  },
  emr: {
    all: ["emr"],
    reference: {
      templates: ["emr", "reference", "templates"],
      fshOptions: ["emr", "reference", "fshOptions"],
      cptCodes: ["emr", "reference", "cptCodes"],
      icdList: ["emr", "reference", "icdList"],
    },
    dashboard: (dateRange) => ["emr", "dashboard", dateRange ?? {}],
    followUps: (requestId) => ["emr", "followUps", requestId],
    attachments: (requestId) => ["emr", "attachments", requestId],
    additionalInfo: (requestId) => ["emr", "additionalInfo", requestId],
    visitNotes: (requestId) => ["emr", "visitNote", requestId],
    visitNote: (requestId, patientUuid) => [
      "emr",
      "visitNote",
      requestId,
      patientUuid ?? null,
    ],
    excuse: (requestId) => ["emr", "excuse", requestId],
    covid: (requestId) => ["emr", "covid", requestId],
    discharge: (requestId) => ["emr", "discharge", requestId],
    receipt: (requestId) => ["emr", "receipt", requestId],
    dbTemplate: (requestId) => ["emr", "dbTemplate", requestId],
    pmh: (patientUuid) => ["emr", "pmh", patientUuid],
    pmhAttachments: (patientUuid) => ["emr", "pmhAttachments", patientUuid],
    patientRequests: (patientUuid) => ["emr", "patientRequests", patientUuid],
    requestScope: (requestId, patientUuid) => [
      "emr",
      "request",
      requestId,
      patientUuid,
    ],
  },
};
